import * as React from "react";

function InvoiceIcon(onClick, props) {
    return (
        <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={19.1} height={16.472}
                viewBox="0 -960 960 960"
                onClick={onClick}
                {...props}
            ><path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z" /></svg>
        </span>
    );
}

export default InvoiceIcon;
